import React from 'react'
import BigTagMenu from './big_tag_menu'

class BigTagOptions extends React.Component {
    showClose() {
        return (
            <div className="big-tag-status">
                <span className="big-tag-close">X</span>
            </div>
        )
    }

    showOptions() {
        this.props.renderInfo(this.props.bigTag)
    }

    renderBigTagMenu() {
        const {
            menuOpen,
            showDropdown,
            editTag,
            newTimeEntry,
            newTimer,
            bigTag,
            showModal,
        } = this.props

        return(
            <BigTagMenu
                menuOpen={menuOpen}
                showDropdown={showDropdown}
                editTag={editTag}
                newTimeEntry={newTimeEntry}
                newTimer={newTimer}
                bigTag={bigTag}
                showModal={showModal}
            />
        )
    }

    render() {
        const { options: { showClose } } = this.props

        return showClose ? this.showClose() : this.renderBigTagMenu()
    }
}

export default BigTagOptions


// WEBPACK FOOTER //
// ./src/components/big_tag_options.jsx